import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Title3, Caption1, Body } from '../../components/Typography';
import ProductSummaryContainer from './ProductSummary/ProductSummaryContainer';
import ComboSummaryContainer from './ComboSummary/ComboSummaryContainer';
import { useState } from 'react';
import GetOptionsForProduct from '../OrderSummaryCart/ProductSummaryCart/utils/getOptionsForProduct';
import CompareTwoObjects from '../OrderSummaryCart/ProductSummaryCart/utils/compareTwoObjects';

const ProductSummaryWrapper = styled.div`
  padding-left: ${(props) => (props.isForPreview ? '0' : '80px')};
  margin-bottom: 40px;
  @media (max-width: 786px) {
    padding-left: 0;
  }
`;

const OrderSummaryWrapper = styled.div`
  display: ${(props) => (props.isFromReviewPage ? 'grid' : 'block')};
  grid-template-columns: ${(props) =>
    props.isFromReviewPage ? '150px 1fr' : '1fr'};

  @media (max-width: 768px) {
    display: block;
    grid-template-columns: 1fr;
  }
`;

const Title3Wrapper = styled(Title3)`
  text-transform: ${(props) => props.theme.reviewCheckoutPageTitle};
  margin-bottom: auto;
  font-weight: 600;

  :after {
    content: '';
    display: block;
    width: 100px;
    padding-top: 2px;
    border-bottom: ${(props) =>
      props.isForPreview
        ? `${props.categoriesBarSelectedBorderColorWidth} solid
      ${props.theme.categoriesBarSelectedBorderColor}`
        : ''};
  }
`;

const ComboWrapper = styled.div`
  margin-left: -15px;
`;

const OrderSummary = ({
  productsInCart,
  combos,
  isForPreview,
  isFromReviewPage,
  favouritesList,
}) => {
  const [updatedProductList, setUpdatedProductList] = useState(productsInCart);
  // comparing fav list with cart products and making cart products as favourite if found in favlist

  const CompareAndUpdateList = useCallback(() => {
    productsInCart.map((cartProduct) => {
      let flatProductOptions = GetOptionsForProduct(cartProduct.flatProduct);
      let favProductOptions = [];

      favouritesList.map((favourite) => {
        favProductOptions = GetOptionsForProduct(favourite.flatProduct);
        let checkObject =
          flatProductOptions?.length !== 0
            ? CompareTwoObjects(favProductOptions, flatProductOptions)
            : true;
        if (
          favourite.flatProduct.product_id ==
            cartProduct.flatProduct.product_id &&
          favourite.flatProduct.variant_id ==
            cartProduct.flatProduct.variant_id &&
          checkObject
        ) {
          cartProduct.favouriteId = favourite.favouriteId;
          cartProduct.isFromFavourite = true;
        }
      });
    });
    setUpdatedProductList(productsInCart);
  }, [productsInCart, favouritesList]);

  useEffect(() => {
    CompareAndUpdateList();
  }, [CompareAndUpdateList]);

  return (
    <OrderSummaryWrapper isFromReviewPage={isFromReviewPage}>
      <Title3Wrapper id='OrderSummary-Title' isForPreview={isForPreview}>
        Order Summary
      </Title3Wrapper>

      <ProductSummaryWrapper isForPreview={isForPreview}>
        {updatedProductList.length > 0 && (
          <div>
            {updatedProductList.map((productInCart, productInCartIndex) => (
              <ProductSummaryContainer
                key={productInCartIndex}
                productInCart={productInCart}
                isLastProductInCart={
                  updatedProductList.length === productInCartIndex + 1 &&
                  combos.length === 0
                }
                // isForPreview={isForPreview}
              />
            ))}
          </div>
        )}
        {combos.length > 0 && (
          <ComboWrapper>
            {combos.map((combo, comboIndex) => (
              <ComboSummaryContainer
                key={`cart-combo-${comboIndex}`}
                comboIndex={comboIndex}
                combo={combo}
              />
            ))}
          </ComboWrapper>
        )}
      </ProductSummaryWrapper>
    </OrderSummaryWrapper>
  );
};

export default OrderSummary;
